import { render, staticRenderFns } from "./tax-summaries.vue?vue&type=template&id=0ede0c97&lang=pug"
import script from "./tax-summaries.vue?vue&type=script&lang=js"
export * from "./tax-summaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports